import { useMemo } from 'react'
import styles from './ArticleGrid.module.scss'
import ArticleCard from 'components/article/article-card/ArticleCard'
import { ArticleGridProps } from './types'
import { Grid } from '@boltenergy-be/design-system'

const ArticleGrid = ({ articles, description, title, limit = 3, action }: ArticleGridProps) => {
  // Constants
  const articlesToShow = useMemo(() => articles.slice(0, limit), [articles, limit])

  return (
    !!articlesToShow.length && (
      <Grid {...{ action, description, title }}>
        {articlesToShow.map((article) => (
          <ArticleCard
            {...article}
            key={`${article.title}-${article.id}`}
            publishedAt={article.customPublishedAt ?? article.publishedAt}
            destination={article.destination}
            className={styles.article}
          />
        ))}
      </Grid>
    )
  )
}

export default ArticleGrid
